import React from 'react';
import { connect } from 'react-redux';
import { v4 } from 'uuid';

import UsageView from '../../components/usage/UsageView';
import {
  getExecuteIdsFromJobIds,
  getUsageExecuteId,
  isUsageExecuting,
} from '../../reducers/analyticsApp';
import { executeUsageQueries, executeUsageQueryCsv, setUsageExecuteId } from '../../actions/usage';
import { cancelRequest } from '../../api/execute';
import CsvDownloadButton from '../navigation/csv/CsvDownloadButton';
import CsvRequests from '../navigation/csv/CsvRequests';

const mapStateToProps = (state) => {
  const executeIds = getExecuteIdsFromJobIds(state);
  const executeId = getUsageExecuteId(state);

  return {
    executing: isUsageExecuting(state),
    cancelButtonDisabled: !executeIds.includes(executeId),
    extraActions: [
      {
        renderElement: (closeMenu) => (
          <CsvDownloadButton
            title="Download CSV"
            clickHandler={executeUsageQueryCsv}
            closeMenu={closeMenu}
          />
        ),
      },
      { renderElement: (closeMenu) => <CsvRequests closeMenu={closeMenu} /> },
    ],
    executeId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onExecute: () => {
    const executeId = v4();
    dispatch(setUsageExecuteId(executeId));
    return dispatch(executeUsageQueries(executeId));
  },
  onRequestCancel: (executeId) => dispatch(cancelRequest(executeId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onRequestCancel: () => dispatchProps.onRequestCancel(stateProps.executeId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UsageView);
